<template>
    <div>
        <v-overlay :model-value="loading"
                   class="align-center justify-center">
            <v-progress-circular color="primary"
                                 indeterminate
                                 size="64"></v-progress-circular>

        </v-overlay>
        <div style="height:500px; width:100%;" class="pa-3">
            <Line v-if="loaded" ref="line" :data="graphData" :options="graphOptions" />
        </div>
    </div>
</template>
<style scoped>
    .number-cell {
        text-align:right!important;
    }
</style>
<script>
    import { numberWithCommas } from "../../mixins/numberMixins";
    import { Line } from 'vue-chartjs'
    function initialState() {
        return {
            loading: false,
            saving: false,
            data: null,
            graphData: [],
            graphOptions: [],
            loaded: false,
        };
    }
    export default {
        name: "ProductionReceivedReport",
        data: function () {
            return initialState();
        },
        mounted: function () {
            this.graphOptions = {
                responsive: true,
                maintainAspectRatio: false,
                plugins: {
                    tooltip: {
                        callbacks: {
                            label: function (context) {
                                return '$' + numberWithCommas(Math.round(context.parsed.y * 100) / 100, 2);
                            }
                        }
                    }
                },
                scales: {
                    y: {
                        ticks: {
                            callback: (label) => '$' + numberWithCommas(Math.round(label * 100) / 100000) + "k"
                        }
                    },
                },
            };
            this.loadReport();
        },
        props: {
            definition: Object
        },
        components: {
            Line
        },
        methods: {
            loadReport(){
                this.errors = null;
                // All good - Run
                this.loading = true;
                let query = [];
                this.$api.get(this.definition.route)
                    .then(res => {
                        this.loading = false;
                        this.data = res.data;
                        this.buildGraphData();
                    }).catch(error => {
                        this.loading = false;
                    });
            },
            numberWithCommas,
            calculateEMA(data, smoothing = 3) {
                const ema = []
                const k = smoothing / (data.length + 1)

                data.forEach((value, i) => {
                    if (i === 0) {
                        ema.push(value)
                    } else {
                        ema.push(value * k + ema[i - 1] * (1 - k))
                    }
                })

                return ema
            },
            buildGraphData() {
                const trendlineData = this.calculateEMA(this.data.receivedData);
                const datasets = [
                    {
                        label: 'Production',
                        fill: false,
                        tension: 0.1,
                        borderColor: '#546E7A',
                        data: this.data.productionData
                    },
                    {
                        label: 'Received',
                        fill: false,
                        tension: 0.1,
                        borderColor: '#00acc1',
                        data: this.data.receivedData,
                        regression: {
                            type: 'linear',
                            line: {
                                color: 'rgba(255,105,180, 0.8)',
                                width: 2
                            }
                        }
                    },
                    {
                        label: 'Received Trendline',
                        data: trendlineData,
                        borderColor: 'rgba(255,105,180, 0.8)',
                        backgroundColor: 'rgba(255,105,180, 0.1)',
                        borderDash: [5, 5],
                        pointRadius: 0,
                        fill: false
                    },
                ];

                const receivedTargetVal = this.data.receivedTarget?.[0] ?? 0;
                const productionTargetVal = this.data.productionTarget?.[0] ?? 0;

                if (receivedTargetVal === productionTargetVal) {
                    datasets.push({
                        label: 'Target',
                        data: this.data.receivedTarget,
                        borderColor: '#4CAF50',
                        pointRadius: 2,
                        fill: false
                    });
                } else {
                    datasets.push({
                        label: 'Received Target',
                        data: this.data.receivedTarget,
                        borderColor: '#4CAF50',
                        pointRadius: 2,
                        fill: false
                    });
                    datasets.push({
                        label: 'Production Target',
                        data: this.data.productionTarget,
                        borderColor: '#FF9800',
                        pointRadius: 2,
                        fill: false
                    });
                }

                this.graphData = {
                    labels: this.data.weeks,
                    datasets: datasets
                };

                this.loaded = true;
            }
        },
        computed: {
        }
    };
</script>